import { useEffect, useState } from "react";

import { formatTimeDiff } from "../../../Tools/FormatTools";

interface ICronometroProps {
    TimeStamp: number;
}

export default function Cronometro(props: ICronometroProps) {
    const [time, setTime] = useState(props.TimeStamp);

    useEffect(() => {
        const timeWatcher = setInterval(() => {
            setTime(time + 1000);
        }, 1000);

        return function cleanup() {
            clearTimeout(timeWatcher);
        };
    }, [time]);

    return <span className="text-monospace"> {formatTimeDiff(time)} </span>;
}
